import { FlowBracket } from "../shared/components/FlowBracket";
import { BracketProps } from "../shared/types/interfaces";
// import frame from "./frame.png";

const matchIndexPositions: { [key: number]: { node: { x: number; y: number } } } = {
  // lower bracket semi final
  0: {
    node: {
      x: 200,
      y: 108,
    },
  },
  // upper bracket final
  1: {
    node: {
      x: 463,
      y: 2,
    },
  },
  // lower bracket final
  2: {
    node: {
      x: 463,
      y: 108,
    },
  },
  3: {
    node: {
      x: 727,
      y: 55,
    },
  },
};

export const DoubleElim4Skewed = ({ gameId, bracket, pickedResults, onTeamClick }: BracketProps) => {
  if (!bracket.matches) return null;

  return (
    <div className="relative w-full">
      <div className="custom-scrollbar relative overflow-x-auto overflow-y-hidden">
        <div
          style={{
            width: "1075px",
            minWidth: "1075px",
            height: "230px",
            minHeight: "230px",
          }}
        >
          {/* For dev only */}
          {/* <img
            className="absolute"
            src={frame}
            style={{
              top: "0",
              width: "1075px",
              minWidth: "1075px",
            }}
          /> */}

          <FlowBracket
            gameId={gameId}
            circuitName={bracket.circuitName}
            tournamentName={bracket.parentTournamentName}
            matchIndexPositions={matchIndexPositions}
            matches={bracket.matches}
            pickedResults={pickedResults}
            onTeamClick={onTeamClick}
          />
        </div>
      </div>
    </div>
  );
};
